
import { createRouter, createWebHistory } from 'vue-router'
import { store } from '../store'

/* Guest Component */
const Login = () => import('../components/auth/Login.vue' /* webpackChunkName: "resource/js/components/login" */)
const Register = () => import('../components/auth/Register.vue' /* webpackChunkName: "resource/js/components/register" */)
const RecoverPassword = () => import('../components/auth/RecoverPassword.vue' /* webpackChunkName: "resource/js/components/recoverPassword" */)
const ResetPassword = () => import('../components/auth/ResetPassword.vue' /* webpackChunkName: "resource/js/components/resetPassword" */)
const FarmRegister = () => import('../components/auth/FarmRegister.vue' /* webpackChunkName: "resource/js/components/farmRegister" */)
/* Guest Component */

/* Layouts */
const DashboardLayout = () => import('../components/layouts/Dashboard.vue' /* webpackChunkName: "resource/js/components/layouts/dashboard" */)
const DefaultLayout = () => import('../components/layouts/Default.vue' /* webpackChunkName: "resource/js/components/layouts/default" */)
/* Layouts */

/* Authenticated Component */
const Temporary = () => import('../components/pages/Temporary.vue' /* webpackChunkName: "resource/js/components/temporary" */)
/* Authenticated Component */

/* SEV */
const SevUserProfile = () => import('../components/sev/SevUserProfile.vue' /* webpackChunkName: "resource/js/components/sev-user-profile" */)
const SevExampleProfile = () => import('../components/sev/SevExampleProfile.vue' /* webpackChunkName: "resource/js/components/sev-example-profile" */)
const SevUnits = () => import('../components/sev/SevUnits.vue' /* webpackChunkName: "resource/js/components/sev-units" */)
/* SEV */

/* Pages Component */
const Terms = () => import('../components/pages/Terms.vue' /* webpackChunkName: "resource/js/components/pages/terms" */)
/* Pages Component */

/* 404 */
const NotFound = () => import('../components/pages/NotFound.vue' /* webpackChunkName: "resource/js/components/pages/not-found" */)
/* 404 */

const Routes = [
    {
        path:"/",
        component:DefaultLayout,
        meta:{
            middleware:"guest",
        },
        children:[
            {
                name:"terms",
                path:"/pogoji-uporabe",
                component:Terms,
                meta:{
                    middleware:"guest",
                    title:"Pogoji uporabe"
                }
            },
        ]
    },
    {
        path:"/sev",
        component:DashboardLayout,
        meta:{
            
        },
        children:[
            {
                name:"dashboard",
                path: '',
                component: SevUserProfile,
                meta:{
                    middleware:"guest",
                    title:`SEV Profil`
                }
            },
            {
                name:"sev-units",
                path: 'enote',
                component: SevUnits,
                meta:{
                    middleware:"guest",
                    title:`SEV Enote`
                }
            },
            {
                name:"sev-example",
                path: 'vzorcna-enota',
                component: SevExampleProfile,
                meta:{
                    middleware:"guest",
                    title:`SEV Vzorčna Enota`
                }
            },
        ]
    },
    {
        name:"login",
        path:"/prijava",
        component:Login,
        meta:{
            middleware:"guest",
            title:"Prijava"
        }
    },
    {
        name:"register",
        path:"/registracija",
        component:Register,
        meta:{
            middleware:"guest",
            title:'Registracija'
        }
    },
    {
        name:"recover-password",
        path:"/pozabljeno-geslo",
        component:RecoverPassword,
        meta:{
            middleware:"guest",
            title:"Pozabljeno geslo"
        }
    },
    {
        name:"reset-password",
        path:"/ponastavi-geslo/:token",
        component:ResetPassword,
        meta:{
            middleware:"guest",
            title:"Ponastavi geslo"
        }
    },
    {
        name:"farm-register",
        path:"/registracija-kmetije",
        component:FarmRegister,
        meta:{
            middleware:"guest",
            title:"Registracija kmetijskega gospodarstva"
        }
    },
    { 
        path: '/stran-ne-obstaja', 
        component: NotFound,
        meta:{
            title:"Stran ne obstaja"
        }
    },  
    { path: '/:pathMatch(.*)*', redirect: '/stran-ne-obstaja' },  
]

const router = createRouter({
    history: createWebHistory(),
    routes: Routes
})

router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title} - ${process.env.MIX_APP_NAME}`
    if(to.meta.middleware=="guest"){
        if (store.state.auth.authenticated) {
            if (to.name == "login") {
                next({name:"dashboard"});
            } else {
                next()
            }
        } else {
            next()
        }
    } else {
        next()
    }
})

export default router

